// extracted by mini-css-extract-plugin
export default {"flexContainer":"PageNotFound_flexContainer__UGN4D","logo":"PageNotFound_logo__QQ8AP"};